module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/okright.6306474.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/okright.png
// module id = rzrz
// module chunks = 0